import React, { FC, Fragment } from 'react';
import { useQuery } from '@apollo/react-hooks';

import GET_PAYMENT_STORES_QUERY from '../graphql/getPaymentStores.graphql';

type Data = {
  paymentGatewayStore: Array<{
    paymentStore: {
      id: string;
      title: string;
      logo: string;
    };
  }>;
};

type PaymentLogosProps = {
  classNameItem: string;
};

const PaymentLogos: FC<PaymentLogosProps> = ({ classNameItem }) => {
  const { loading, data, error } = useQuery<Data>(GET_PAYMENT_STORES_QUERY);

  if (error) {
    return null;
  }

  if (loading || !data?.paymentGatewayStore) {
    return null;
  }

  return (
    <Fragment>
      {data.paymentGatewayStore
        .map(el => el.paymentStore)
        .filter(el => el.logo)
        .slice(0, 6)
        .map((el, index) => (
          <div key={index} className={classNameItem}>
            <img
              className="block w-auto"
              src={el.logo}
              alt={el.title}
              style={{ height: 18 }}
            />
          </div>
        ))}
    </Fragment>
  );
};

export default PaymentLogos;
